import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Section } from '../../layout';
import { Button } from '../../ui/Button';
import { TherapistCard, TherapistCardProps } from './TherapistCard';
import { cn } from '../../../utils/cn';

// Mock therapist data
const mockTherapists: Omit<TherapistCardProps, 'className'>[] = [
  {
    id: 'sarah-johnson',
    name: 'Sarah Johnson',
    title: 'Swedish & Deep Tissue Specialist',
    yearsExperience: 8,
    bio: 'Sarah combines her expertise in Swedish and deep tissue techniques to create customized treatments. She is passionate about helping clients achieve lasting relief from chronic tension.',
  },
  {
    id: 'michael-chen',
    name: 'Michael Chen',
    title: 'Sports Massage Specialist',
    yearsExperience: 12,
    bio: 'With over a decade of experience working with athletes, Michael specializes in injury prevention and recovery. His approach integrates sports science with therapeutic massage.',
  },
  {
    id: 'emily-rodriguez',
    name: 'Emily Rodriguez',
    title: 'Prenatal & Aromatherapy Specialist',
    yearsExperience: 6,
    bio: 'Emily brings a nurturing touch to her practice, specializing in prenatal massage and aromatherapy. She creates a calming environment for expectant mothers and stress relief seekers.',
  },
  {
    id: 'david-kim',
    name: 'David Kim',
    title: 'Hot Stone & Relaxation Specialist',
    yearsExperience: 10,
    bio: 'David is known for his expertise in hot stone therapy and relaxation techniques. His sessions are designed to melt away stress and restore mind-body balance.',
  },
];

export interface TherapistSpotlightProps {
  /**
   * Additional CSS classes
   */
  className?: string;
}

export const TherapistSpotlight: FC<TherapistSpotlightProps> = ({ className }) => {
  return (
    <Section
      spacing="lg"
      className={cn('bg-white dark:bg-slate-900', className)}
      aria-labelledby="therapists-heading"
    >
      {/* Section Header */}
      <div className="mb-12 text-center">
        <h2
          id="therapists-heading"
          className="mb-4 font-serif text-3xl font-bold text-gray-900 dark:text-slate-100 sm:text-4xl"
        >
          Meet Our Expert Team
        </h2>
        <p className="mx-auto max-w-2xl text-lg text-gray-600 dark:text-slate-400">
          Our licensed massage therapists bring years of experience and specialized training to
          provide you with exceptional care tailored to your needs.
        </p>
      </div>

      {/* Therapists Grid */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {mockTherapists.map((therapist) => (
          <TherapistCard key={therapist.id} {...therapist} />
        ))}
      </div>

      {/* Meet the Team Button */}
      <div className="mt-12 text-center">
        <Link to="/therapists">
          <Button variant="primary" size="lg">
            Meet the Team
          </Button>
        </Link>
      </div>
    </Section>
  );
};

TherapistSpotlight.displayName = 'TherapistSpotlight';
